import { login } from "@/services/user.service"
import { markRaw } from "vue"
import EmployeeAvatar from "@/components/EmployeeAvatar.vue"

const state = {
  cognitoUser: null,
  sites: null,
  id: null,
  preloadData: {
    employees: null,
    teams: null,
    labor_types: null,
  },
  assets: {},
  locations: {},
  allEmployeesData: [],
  employeesUserId: {},
  usersObj: {},
  allTeamsData: [],
  tenantEmployees: [],
  teamsAcrossSites: {},
  selPage: "",
  showHeader: false,
  topOfPage: true,
  errorMsg: ""
};
const getters = {
  getCognitoUser: state => state.cognitoUser,
  cognitoUsername: state => state.cognitoUser?.username,
  userId: state => state.id,
  employeeName: state => state.name,
  authUserMsg: state => state.errorMsg,    
  siteAssets: state => state.assets,
  assetOptions: state => {
    let options = [{ id: "", name: "All" }]
    for (let [assetId, assetObj] of Object.entries(state.assets)) {
      options.push({ id: assetId, name: assetObj.name, asset_model_id: assetObj.asset_model_id })
    }
    return options
  },
  STPreloadData: state => state.preloadData,
  siteEmployees: state => state.preloadData.employees,
  hiddenSiteEmployees: state => state.preloadData.hidden_employees,
  allSiteEmployees: state => { return { ...state.preloadData.employees, ...state.preloadData.hidden_employees } },
  fullEmployeeData: state => state.allEmployeesData,
  employeeOptions: state => {
    let options = [{
      id: "",
      name: "All",
      dropdownAppend: {
        position: "left",
        component: markRaw(EmployeeAvatar),
        props: {
          employee: { id: "", name: "All" }
        },
        showOnlyInDropdown: true
      }
    }]
    for (let employeeId in state.preloadData.employees) {
      options.push({
        id: employeeId,
        name: state.preloadData.employees[employeeId],
        dropdownAppend: {
          position: "left",
          component: markRaw(EmployeeAvatar),
          props: {
            employee: { id: employeeId, name: state.preloadData.employees[employeeId] }
          }
        }
      })
    }
    return options
  },
  getEmployeesUserId: state => state.employeesUserId,
  getUsersObj: state => state.usersObj,
  siteTeams: state => state.preloadData.teams,
  stealthSiteTeams: state => state.preloadData.stealth_teams,
  allSiteTeams: state => { return { ...state.preloadData.teams, ...state.preloadData.stealth_teams } },
  teamsAcrossSites: state => state.teamsAcrossSites,
  teamOptions: state => {
    let options = [{ id: "", name: "All" }]
    for (let teamId in state.preloadData.teams) {
      options.push({ id: teamId, name: state.preloadData.teams[teamId] })
    }
    return options
  },
  fullTeamsData: state => state.allTeamsData,
  getTenantEmployees: state => state.tenantEmployees,
  getLaborTypes: state => state.preloadData.labor_types,
  getLocations: state => state.locations,
  STPage: state => state.selPage,
  showingModuleHeader: state => state.showHeader,
  atTopOfPage: state => state.topOfPage
};
const actions = {
  async ATLogIn({commit, state}, token) {
    return login(token).then((response) => {
      if (response && response?.status === 200) {
        state.errorMsg = null
        console.log(response.data.sites)
        commit('setSessionID', response.data.session_id)
        // commit('setSites', response.data.sites)
        commit('setSites', {
          'bbccccfd-b7fa-4755-b4d7-27ae5b979cec': {
            name: "DeltaSite",
            employee_id: '3842359b-5816-436e-b971-ba349060a88f',
            employee_name: 'jim',
            tenant_id: "2111794"
          }
        })
        commit('setEmployeeName', response.data.sites)
        /**
         * CHANGE ME TO RETURN OBJECT INSTEAD OF THIS VVVVV
         */
        commit('setPermissionSet', {
          sitecommand:{
            read: false,
            write: false,
          },
          sitetrack:{
            read: false,
            write: false,
          },
          siteunite:{
            read: false,
            write: false,
          },
          sitescan:{
            read: false,
            write: false,
          },
          manager_tools: false,
          tenant_super_user: false})
        return response
      }
      else if (response.status) {
        console.log(response)
        state.errorMsg = 'An error occured'
        return response
      }
      else if (response.code === 'ENOTFOUND' || response.code === 'ECONNRESET') {
        console.log(response)
        state.errorMsg = 'Unable to reach the servers'
        return response
      }
    }, (error) => {
      console.log(error)
      state.errorMsg = 'An error occured'
      return {status: 500}
    })
  },
  setSTData({commit, state}, obj) {
    state.preloadData = obj
    console.log("preloadData", obj)
    commit("setValueLoaded", "preloadData")
  },
  setSiteAssets({commit, state}, assetArr) {
    let assetObj = {}
    for (let asset of assetArr) {
      assetObj[asset.id] = {
        name: asset.name,
        asset_model_id: asset.asset_model_id
      }
    }
    state.assets = assetObj
    commit("setValueLoaded", "assets")
  },
  setLocations({commit, state}, locationArr) {
    let locationObj = {}
    for (let location of locationArr) {
      locationObj[location.id] = location.name
    }
    state.locations = locationObj
    commit("setValueLoaded", "locations")
  },
  setFullEmployeeData({commit, state}, data) {
    state.allEmployeesData = data
    for (let employee of data) {
      state.employeesUserId[employee.id] = employee.user_id
      if (employee.user_id) state.usersObj[employee.user_id] = employee
    }
    commit("setValueLoaded", "allEmployeesData")
  },
  setFullTeamsData({commit, state}, data) {
    state.allTeamsData = data
    commit("setValueLoaded", "allTeamsData")
  },
};
const mutations = {
  LogOutAT(state) {
    state.cognitoUser = null
    state.name = null
    state.id = null
    state.preloadData = {
      employees: null,
      teams: null,
      labor_types: null,
    }
  },
  setSites(state, obj) {
    state.sites = obj
  },
  setEmployeeName(state, data) {
    let firstSite = Object.keys(data)[0]
    let name = data[firstSite].employee_name
    let id = data[firstSite].employee_id
    state.name = name
    state.id = id
  },
  setSTPage(state, option) {
    state.selPage = option
  },
  setATLoginTime(state, time) {
    state.ATLoginTime = time
  },
  showModuleHeader(state, bool) {
    state.showHeader = bool
  },
  setAtTopOfPage(state, bool) {
    state.topOfPage = bool
  },
  setAuthErrorMsg(state, msg) {
    state.errorMsg = msg
  },
  setTenantEmployees(state, arr) {
    state.tenantEmployees = arr
  },
  setSiteTeams(state, arr) {
    let visible = {}
    let stealth = {}
    for (let team of arr) {
      if (team.stealth) stealth[team.id] = team.name
      else visible[team.id] = team.name
      if (!state.teamsAcrossSites[team.site_id]) state.teamsAcrossSites[team.site_id] = {}
      state.teamsAcrossSites[team.site_id][team.id] = team.name
    }
    state.preloadData.teams = visible
    state.preloadData.stealth_teams = stealth
  },
  setTeamsAcrossSites(state, obj) {
    state.teamsAcrossSites = obj
  },
  addLocation(state, location) {
    state.locations[location.id] = location.name
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
